export default __webpack_public_path__ + "static/media/image_5.e7a2f08c.jpg";